module.exports = __webpack_public_path__ + "img/P800.e9cdc169.jpg";